import React from 'react';
import { Link } from 'react-router';

export default class Footer extends React.Component {
  render() {
    let children = this.props.children && this.props.children.length > 0
      ? <div className="block right">{this.props.children}</div>
      : null;

    return (
      <footer className="main-footer">
        <div className="block">
          <h3>Help</h3>
          <ul>
            <li><a href="mailto:contact@indigofair.com">Contact</a></li>
            <li><Link to="/tos">Terms of Service</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div className="block">
          <h3>Company</h3>
          <ul>
            <li><Link to="/team">Team</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><a href="mailto:careers@indigofair.com">Careers</a></li>
          </ul>
        </div>
        <div className="block">
          <h3>Connect</h3>
          <ul>
            <li><a href="https://medium.com/@max_150/betting-big-on-local-retail-1aa9706c4e04#" target="_blank">Blog</a></li>
            <li><a href="https://www.facebook.com/IndigoFairInc/" target="_blank">Facebook</a></li>
            <li><a href="https://twitter.com/indigofair" target="_blank">Twitter</a></li>
            <li><a href="https://www.instagram.com/indigo.fair/" target="_blank">Instagram</a></li>
          </ul>
        </div>
        {children}
      </footer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Home/Footer.js
 **/